
//CurrencyBindingValues
export class CurrencyConversionProperties  {
  currencyFrom: string = "";
  currencyTo: string = "";
  currencyToCode: string = "";
  currencyToCountry: string = "";
  currencyValue: number = 0;
 // usdToCurrencyValue: number = 0AED-UAE Dirham -United Arab Emirates;
}

export class CurrencyObject {
  currencyCode: string = "";
  currencyCountry: string = "";

}

export class CurrencyInfo {
  currencyInformProp: string = "";
  currencyvalue: number;

}
